import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sm/wds-react';
import { createURL } from '@sm/utils';
import { T, defineMessages } from '@sm/intl';

const COPY = defineMessages({
  LOG_IN: {
    id: 'LogInCTA.logInButton',
    defaultMessage: 'LOG IN',
    description:
      '[Type: Label][Vis.: high] - This is the LogIn button on the header.'
  }
});

export const LogInCTA = ({
  variant,
  size,
  color,
  className,
  stretched,
  params
}) => {
  return (
    <Button
      data-testid="LogInCTA__Btn"
      variant={variant}
      size={size}
      color={color}
      stretched={stretched}
      className={className}
      href={createURL('/user/sign-in', params)}
    >
      <T desc={COPY.LOG_IN} />
    </Button>
  );
};

LogInCTA.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  stretched: PropTypes.bool,
  className: PropTypes.string,
  params: PropTypes.oneOfType([PropTypes.object])
};

LogInCTA.defaultProps = {
  variant: 'text',
  size: 'sm',
  color: 'secondary',
  stretched: false,
  className: '',
  params: null
};

export default LogInCTA;
